import { defineComponent, computed } from "vue";
import { o as omit_1 } from "../../../vendor-b303cd6e.mjs";
import { V as VaButton } from "../va-button/index-1db585d5.mjs";
import { V as VaConfig } from "../va-config/VaConfig-785c45a1.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useBem } from "../../composables/useBem-a19cd502.mjs";
const VaButtonProps = omit_1(extractComponentProps(VaButton), ["block"]);
const _sfc_main = defineComponent({
  name: "VaButtonGroup",
  components: { VaConfig },
  props: {
    ...VaButtonProps,
    ...useComponentPresetProp,
    grow: {
      type: Boolean,
      default: false
    }
  },
  setup: (props) => {
    const buttonConfig = computed(() => ({ VaButton: { ...props } }));
    const computedClass = useBem("va-button-group", () => ({
      square: !props.round,
      grow: props.grow,
      small: props.size === "small",
      large: props.size === "large"
    }));
    return { buttonConfig, computedClass };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaButtonGroup.vue_vue_type_script_lang-3ce8af8b.mjs.map
